angular.module('unica_invitation.invitation_services', []);